import { engineComponent } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { Style } from "../Components/Elements/Styles/Style";

/**
 *
 * Example:
 *   <PlaneRopeStyle Class="PlaneRopeStyle">
 <Animation>
 <Frame Frame="0">
 <X MoveAllPointsX="0;0;0;0;0;0;0;0;0"/>
 <Y MoveAllPointsY="0;0;0;0;0;0;0;0;0"/>
 </Frame>

 <Frame Frame="30">
 <X MoveAllPointsX="0;0;0;-10;0;10;0;0;0"/>
 <Y MoveAllPointsY="0;-10;0;0;0;0;0;10;0"/>
 </Frame>

 <Frame Frame="60">
 <X MoveAllPointsX="0;0;0;-20;0;20;0;0;0"/>
 <Y MoveAllPointsY="0;-20;0;0;0;0;0;20;0"/>
 </Frame>

 <Frame Frame="90">
 <X MoveAllPointsX="0;0;0;-30;0;30;0;0;0"/>
 <Y MoveAllPointsY="0;-30;0;0;0;0;0;30;0"/>
 </Frame>

 <Frame Frame="120">
 <X MoveAllPointsX="0;0;0;-20;0;20;0;0;0"/>
 <Y MoveAllPointsY="0;-20;0;0;0;0;0;20;0"/>
 </Frame>
 </Animation>
 </PlaneRopeStyle>
 * @class TimelineStyle
 * @extends Style
 */
@engineComponent(ComponentTypes.Style)
export class PlaneRopeStyle extends Style {
    // container: ContainerElement;

    // xml nodes added to object by frame
    frames: Object;
    positionX: Object;
    positionY: Object;

    constructor() {
        super();

        this.frames = {};
        this.positionX = {};
        this.positionY = {};
    }

    /**
     * Get attributes from xml and set up supported properties.
     * @method create
     * @param node is Element from xml
     * @return void
     */
    create(node: Element): void {
        super.create(node);

        let next: Element = node.firstElementChild;
        while (next != null) {
            switch (next.nodeName) {
                // case 'Elements':
                //     this.container = new ContainerElement();
                //     this.container.create(next);
                //     break;
                case "Animation":
                    var nextCase: Element = next.firstElementChild;
                    while (nextCase != null) {
                        if (nextCase.hasAttribute("Frame")) {
                            if (this.frames[nextCase.getAttribute("Frame")] !== null) {
                                this.frames[nextCase.getAttribute("Frame")] = nextCase;

                                let nextChild: Element = nextCase.firstElementChild;
                                while (nextChild != null) {
                                    if (nextChild.hasAttribute("MoveAllPointsX")) {
                                        this.positionX[nextCase.getAttribute("Frame")] =
                                            nextChild.getAttribute("MoveAllPointsX");
                                    } else if (nextChild.hasAttribute("MoveAllPointsY")) {
                                        this.positionY[nextCase.getAttribute("Frame")] =
                                            nextChild.getAttribute("MoveAllPointsY");
                                    }
                                    nextChild = nextChild.nextElementSibling;
                                }
                            } else {
                                if (DEBUG) {
                                    this.log(
                                        "ERROR case " +
                                            nextCase.getAttribute("Frame") +
                                            " already exist in PlaneRopeStyle " +
                                            node.nodeName,
                                    );
                                }
                            }
                        }
                        nextCase = nextCase.nextElementSibling;
                    }
                    break;
            }
            next = next.nextElementSibling;
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/PlaneRopeStyle.ts
 **/